<script>
  import { onDestroy, getContext } from 'svelte';
  import { fade } from 'svelte/transition';

  export let activeCard = 0;
  export let typologyTable = {};
  export let project = {};

  const { index } = getContext('SetIndex');
  let cardIndex = index();

  let flipped = false;
  let image = project.image && project.image.length ? project.image[0] : {};
  let imageSrc = image.transform && image.transform.length ? image.transform[1] : {};
  let imageAlt = project.imageAlt ?? '';
  let year = project.year ?? '';
  let title = project.title ?? '';
  let url = project.url ?? '';
  let neighborhood = project.neighborhood && project.neighborhood.length ? project.neighborhood[0].title : '';
  let designer = project.designer && project.designer.length ? project.designer[0].title : '';
  let typologies = project.typologies ?? [];

  function flip () {
    activeCard = cardIndex;
  }

  function close () {
    activeCard = 0;
  }

  $: flipped = activeCard === cardIndex;

  onDestroy(() => {
    if (activeCard === cardIndex) {
      activeCard = 0
    }
  });
</script>

<div class="card" class:flipped on:click|stopPropagation={flip} transition:fade={{duration: 200}}>
  <div class="card-inner">
    <button class="card-face card-face-front" aria-expanded="{flipped}" aria-controls="card-content-{project.id}">
      {#if image}
        <img src="{imageSrc.url}"
             srcset="{image.srcset}"
             sizes="(min-width: 1,687px) 300px,
                    (min-width: 1,439px) calc(25vw - 126px),
                    (min-width: 1191px) calc(33.3vw - 162px),
                    (min-width: 943px) calc(50vw - 234px),
                    (min-width: 800px) calc(100vw - 450px),
                    (min-width: 791px) calc(33.3vw - 28px),
                    (min-width: 543px) calc(50vw - 34px),
                    calc(100vw - 50px)"
             width="{imageSrc.width}" height="{imageSrc.height}"
             alt="{imageAlt}"
             loading="lazy">
      {/if}
    </button>

    <div class="card-face card-face-back" id="card-content-{project.id}">
      <dl>
        {#if year}
          <div class="card-group">
            <dt class="card-key">Year</dt>
            <dd class="card-value">{year}</dd>
          </div>
        {/if}
        {#if title}
          <div class="card-group card-group-title">
            <dt class="visually-hidden">Title</dt>
            <dd class="card-value">
              <a href="{url}">{title}</a>
            </dd>
          </div>
        {/if}
        {#if neighborhood}
          <div class="card-group">
            <dt class="card-key">Neighborhood</dt>
            <dd class="card-value">{neighborhood}</dd>
          </div>
        {/if}
        {#if designer}
          <div class="card-group">
            <dt class="card-key">Designer</dt>
            <dd class="card-value">{designer}</dd>
          </div>
        {/if}
        {#if typologies.length}
          <div class="card-group card-group-typology">
            <dt class="card-key">Typology</dt>
            <dd class="card-value">
              <!-- svelte-ignore a11y-no-redundant-roles -->
              <ul class="list-inline" role="list">
                {#each typologies as { id }}
                  {#if typologyTable[id]}
                    <li class="list-inline-item card-typology" style="color:{typologyTable[id].color}" title="{typologyTable[id].title}">
                      <span class="visually-hidden">{typologyTable[id].title}</span>
                    </li>
                  {/if}
                {/each}
              </ul>
            </dd>
          </div>
        {/if}
      </dl>
      <button type="button" class="btn-close btn-close-tiny" aria-label="Close" on:click|stopPropagation={close}></button>
    </div>
  </div>
</div>
